import { render, staticRenderFns } from "./OddsCell.vue?vue&type=template&id=771ab57e&"
import script from "./OddsCell.vue?vue&type=script&lang=js&"
export * from "./OddsCell.vue?vue&type=script&lang=js&"
import style0 from "./OddsCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports